import { FiSearch } from 'react-icons/fi';
import styles from './SearchBar.module.css';

const SearchBar = ({ placeholder = 'Search...', value, onChange }) => {
  return (
    <form className={styles.searchBar} onSubmit={(e) => e.preventDefault()}>
      <FiSearch className={styles.icon} />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={styles.input}
      />
    </form>
  );
};

export default SearchBar;